module.exports = __webpack_public_path__ + "img/recovery-convert.e96aa145.svg";